import {
    FilterAccordionItem,
    FilterCheckbox,
} from 'components/FilterAccordion';
import {
    LIFE_CYCLE_STYLES,
    LIFE_CYCLE_TOOLTIP_CONTENT_CLASSNAME,
    LifeCycleDefinitionsBody,
} from 'components/LifeCycleBadge';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/ui/design-system/components/ui/tooltip';
import { MdClose } from 'react-icons/md';
import { TbChartHistogram } from 'react-icons/tb';
import { lifeCycleFilterOptions } from 'utils/filters';

function LifeCycleSwatch({ value }) {
    const styles = LIFE_CYCLE_STYLES[value] || LIFE_CYCLE_STYLES.none;
    return (
        <span
            className={`inline-block size-2 rounded-[2px] shrink-0 mr-2 ${styles.square}`}
        />
    );
}

function LifeCycleDefinitionsTooltip({ children }) {
    return (
        <TooltipProvider delayDuration={300}>
            <Tooltip>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipContent
                    className={LIFE_CYCLE_TOOLTIP_CONTENT_CLASSNAME}
                    sideOffset={8}
                >
                    <LifeCycleDefinitionsBody />
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}

export function LifeCycleFilterOption({ children, value, ...props }) {
    return (
        <FilterCheckbox {...props}>
            <LifeCycleSwatch value={value} />
            {children}
        </FilterCheckbox>
    );
}

function LifeCycleFilterChipItemButton({ children, value, onClick }) {
    const styles = LIFE_CYCLE_STYLES[value] || LIFE_CYCLE_STYLES.none;
    return (
        <LifeCycleDefinitionsTooltip>
            <button
                type="button"
                onClick={onClick}
                className={`${styles.badge} capitalize shrink-0 text-[10px] inline-flex items-center justify-center gap-1 rounded-md border px-2 py-px font-medium cursor-pointer transition-colors hover:brightness-95`}
            >
                <span
                    className={`size-2 rounded-[2px] shrink-0 ${styles.square}`}
                />
                {children}
                <MdClose className="size-3.5" />
            </button>
        </LifeCycleDefinitionsTooltip>
    );
}

function LifeCycleFilterAccordionItem({
    label = 'Life Cycle',
    options = lifeCycleFilterOptions,
    mixpanelContext = 'LifeCycleFilterSelect',
    Icon = TbChartHistogram,
    FilterOption = LifeCycleFilterOption,
    FilterChipItemButton = LifeCycleFilterChipItemButton,
    ...props
}) {
    return (
        <FilterAccordionItem
            label={label}
            options={options}
            mixpanelContext={mixpanelContext}
            Icon={Icon}
            FilterOption={FilterOption}
            FilterChipItemButton={FilterChipItemButton}
            {...props}
        />
    );
}

export default LifeCycleFilterAccordionItem;
